webpackJsonp([1],{

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_index_Home__ = __webpack_require__(268);




__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_index_Home__["a" /* default */]
  }]
}));

/***/ }),

/***/ 129:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(91);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b90d92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(275);
function injectStyle (ssrContext) {
  __webpack_require__(253)
}
var normalizeComponent = __webpack_require__(16)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10b90d92_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getStatisticsInfo;
/* harmony export (immutable) */ __webpack_exports__["b"] = getStatisticsInfo1day;
/* harmony export (immutable) */ __webpack_exports__["c"] = getInfo7days;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__(22);

var baseUrl =  true ? '' : '/packmap';
// const baseUrl = ''
function getStatisticsInfo(parkfieldId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/lcchargerlog/getStatisticsInfo',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  });
}
function getStatisticsInfo1day(parkfieldId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/lcchargerlog/getStatisticsInfo1day',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  });
}
function getInfo7days(parkfieldId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/lcchargerlog/getInfo7days',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  });
}

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = logout;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__(22);

var baseUrl =  true ? '' : '/packmap';
// const baseUrl = ''
function logout() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/lcmanager/logout',
    method: 'get'
  });
}

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getMonitorInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__(22);

var baseUrl =  true ? '' : '/packmap';
// const baseUrl = ''
function getMonitorInfo(parkFieldId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/lcmonitorinfo/getLcMonitorInfoByparkfieldId',
    method: 'get',
    params: {
      parkFieldId: parkFieldId
    }
  });
}

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getparkNum */
/* unused harmony export getparkIncome */
/* harmony export (immutable) */ __webpack_exports__["a"] = getparkList;
/* harmony export (immutable) */ __webpack_exports__["b"] = getCharageStatus;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_request__ = __webpack_require__(22);

var baseUrl =  true ? '' : '/packmap';
// const baseUrl = ''
function getparkNum(parkfieldId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/parkinfo/getparkNum',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  });
}
function getparkIncome(parkfieldId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/parkinfo/getparkIncome',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  });
}
function getparkList() {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/lcparkfield',
    method: 'get'
  });
}
function getCharageStatus(parkfieldId) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_request__["a" /* default */])({
    url: baseUrl + '/lcparkfield/charageStatus',
    method: 'get',
    params: {
      parkfieldId: parkfieldId
    }
  });
}

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App_vue__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__(27);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.





__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__webpack_require__(26));
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$utils = __webpack_require__(37);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$commons = __webpack_require__(20);

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_1__App_vue__["a" /* default */]
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export parseTime */
/* unused harmony export formatTime */
/* unused harmony export getQueryObject */
/* unused harmony export byteLength */
/* unused harmony export cleanArray */
/* unused harmony export param */
/* unused harmony export param2Obj */
/* unused harmony export html2Text */
/* unused harmony export objectMerge */
/* unused harmony export toggleClass */
/* unused harmony export getTime */
/* harmony export (immutable) */ __webpack_exports__["a"] = debounce;
/* unused harmony export deepClone */
/* unused harmony export uniqueArr */
/* unused harmony export createUniqueString */
/* unused harmony export hasClass */
/* unused harmony export addClass */
/* unused harmony export removeClass */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof__);




/**
 * Created by PanJiaChen on 16/11/18.
 */

/**
 * Parse the time to string
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null;
  }
  var format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
  var date = void 0;
  if ((typeof time === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(time)) === 'object') {
    date = time;
  } else {
    if (typeof time === 'string') {
      if (/^[0-9]+$/.test(time)) {
        // support "1548221490638"
        time = parseInt(time);
      } else {
        // support safari
        // https://stackoverflow.com/questions/4310953/invalid-date-in-safari
        time = time.replace(new RegExp(/-/gm), '/');
      }
    }

    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000;
    }
    date = new Date(time);
  }
  var formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  };
  var timeStr = format.replace(/{([ymdhisa])+}/g, function (result, key) {
    var value = formatObj[key];
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value];
    }
    return value.toString().padStart(2, '0');
  });
  return timeStr;
}

/**
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000;
  } else {
    time = +time;
  }
  var d = new Date(time);
  var now = Date.now();

  var diff = (now - d) / 1000;

  if (diff < 30) {
    return '刚刚';
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前';
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前';
  } else if (diff < 3600 * 24 * 2) {
    return '1天前';
  }
  if (option) {
    return parseTime(time, option);
  } else {
    return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
  }
}

/**
 * @param {string} url
 * @returns {Object}
 */
function getQueryObject(url) {
  url = url == null ? window.location.href : url;
  var search = url.substring(url.lastIndexOf('?') + 1);
  var obj = {};
  var reg = /([^?&=]+)=([^?&=]*)/g;
  search.replace(reg, function (rs, $1, $2) {
    var name = decodeURIComponent($1);
    var val = decodeURIComponent($2);
    val = String(val);
    obj[name] = val;
    return rs;
  });
  return obj;
}

/**
 * @param {string} input value
 * @returns {number} output value
 */
function byteLength(str) {
  // returns the byte length of an utf8 string
  var s = str.length;
  for (var i = str.length - 1; i >= 0; i--) {
    var code = str.charCodeAt(i);
    if (code > 0x7f && code <= 0x7ff) s++;else if (code > 0x7ff && code <= 0xffff) s += 2;
    if (code >= 0xDC00 && code <= 0xDFFF) i--;
  }
  return s;
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
function cleanArray(actual) {
  var newArray = [];
  for (var i = 0; i < actual.length; i++) {
    if (actual[i]) {
      newArray.push(actual[i]);
    }
  }
  return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
function param(json) {
  if (!json) return '';
  return cleanArray(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(json).map(function (key) {
    if (json[key] === undefined) return '';
    return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
  })).join('&');
}

/**
 * @param {string} url
 * @returns {Object}
 */
function param2Obj(url) {
  var search = url.split('?')[1];
  if (!search) {
    return {};
  }
  return JSON.parse('{"' + decodeURIComponent(search).replace(/"/g, '\\"').replace(/&/g, '","').replace(/=/g, '":"').replace(/\+/g, ' ') + '"}');
}

/**
 * @param {string} val
 * @returns {string}
 */
function html2Text(val) {
  var div = document.createElement('div');
  div.innerHTML = val;
  return div.textContent || div.innerText;
}

/**
 * Merges two objects, giving the last one precedence
 * @param {Object} target
 * @param {(Object|Array)} source
 * @returns {Object}
 */
function objectMerge(target, source) {
  if ((typeof target === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(target)) !== 'object') {
    target = {};
  }
  if (Array.isArray(source)) {
    return source.slice();
  }
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(source).forEach(function (property) {
    var sourceProperty = source[property];
    if ((typeof sourceProperty === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(sourceProperty)) === 'object') {
      target[property] = objectMerge(target[property], sourceProperty);
    } else {
      target[property] = sourceProperty;
    }
  });
  return target;
}

/**
 * @param {HTMLElement} element
 * @param {string} className
 */
function toggleClass(element, className) {
  if (!element || !className) {
    return;
  }
  var classString = element.className;
  var nameIndex = classString.indexOf(className);
  if (nameIndex === -1) {
    classString += '' + className;
  } else {
    classString = classString.substr(0, nameIndex) + classString.substr(nameIndex + className.length);
  }
  element.className = classString;
}

/**
 * @param {string} type
 * @returns {Date}
 */
function getTime(type) {
  if (type === 'start') {
    return new Date().getTime() - 3600 * 1000 * 24 * 90;
  } else {
    return new Date(new Date().toDateString());
  }
}

/**
 * @param {Function} func
 * @param {number} wait
 * @param {boolean} immediate
 * @return {*}
 */
function debounce(func, wait, immediate) {
  var timeout = void 0,
      args = void 0,
      context = void 0,
      timestamp = void 0,
      result = void 0;

  var later = function later() {
    // 据上一次触发时间间隔
    var last = +new Date() - timestamp;

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      }
    }
  };

  return function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    context = this;
    timestamp = +new Date();
    var callNow = immediate && !timeout;
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };
}

/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 * @param {Object} source
 * @returns {Object}
 */
function deepClone(source) {
  if (!source && (typeof source === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(source)) !== 'object') {
    throw new Error('error arguments', 'deepClone');
  }
  var targetObj = source.constructor === Array ? [] : {};
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(source).forEach(function (keys) {
    if (source[keys] && __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_typeof___default()(source[keys]) === 'object') {
      targetObj[keys] = deepClone(source[keys]);
    } else {
      targetObj[keys] = source[keys];
    }
  });
  return targetObj;
}

/**
 * @param {Array} arr
 * @returns {Array}
 */
function uniqueArr(arr) {
  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(arr));
}

/**
 * @returns {string}
 */
function createUniqueString() {
  var timestamp = +new Date() + '';
  var randomNum = parseInt((1 + Math.random()) * 65536) + '';
  return (+(randomNum + timestamp)).toString(32);
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'));
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls;
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    var reg = new RegExp('(\\s|^)' + cls + '(\\s|$)');
    ele.className = ele.className.replace(reg, ' ');
  }
}

/***/ }),

/***/ 20:
/***/ (function(module, exports) {

/* global $ */
var camerasMap = {};
var camerasCount = 0;
var names = {};
var duplicates = {};
var hiddenCamerasMap = {};
var _walkCameras = function _walkCameras(items, parentText, deduplication) {
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    var id = item.id;
    var text = parentText ? parentText + '_' + item.text : item.text;
    if (item.id.indexOf('c_') === 0) {
      item.icon = '/static/images/tree_c.png';
      if (deduplication !== false) {
        var representId = names[text];
        if (representId) {
          if (duplicates[representId]) {
            duplicates[representId].push(id);
          } else {
            duplicates[representId] = [id];
          }
          hiddenCamerasMap[id] = item;
          items.splice(i, 1);
          i--;
        } else {
          names[text] = id;
          camerasMap[id] = item;
          camerasCount++;
        }
      } else {
        camerasMap[id] = item;
        camerasCount++;
      }
    } else {
      item.icon = '/static/images/tree_o.png';
      if (item.children && item.children.length > 0) {
        _walkCameras(item.children, text, deduplication);
      }
    }
  }
};
if (window.$camerasTree) {
  _walkCameras(window.$camerasTree.children);
  names = null;
}
module.exports = {
  walkCameras: function walkCameras() {
    camerasCount = 0;
    _walkCameras.apply(this, arguments);
  },
  getCameraName: function getCameraName(id) {
    var camera = camerasMap[id];
    if (camera) {
      return camera.text;
    } else if (hiddenCamerasMap[id]) {
      return hiddenCamerasMap[id].text;
    } else {
      return null;
    }
  },
  getCamera: function getCamera(id) {
    return camerasMap[id] || hiddenCamerasMap[id];
  },
  getCameras: function getCameras(ids) {
    var cameras = [];
    for (var i = 0; i < ids.length; i++) {
      var id = ids[i];
      if (camerasMap[id]) {
        cameras.push(ids[i]);
      }
    }
    return cameras;
  },
  countCameras: function countCameras() {
    return camerasCount;
  },
  filterCameras: function filterCameras(filter) {
    var cameras = [];
    for (var id in camerasMap) {
      var camera = camerasMap[id];
      if (!filter || filter(camera)) {
        cameras.push(camera);
      }
    }
    return cameras;
  },
  filterCameraIds: function filterCameraIds(filter) {
    var cameraIds = [];
    for (var id in camerasMap) {
      var camera = camerasMap[id];
      if (!filter || filter(camera)) {
        cameraIds.push(camera.id);
      }
    }
    return cameraIds;
  },
  getDuplicateCameraIds: function getDuplicateCameraIds(id) {
    return duplicates[id];
  },
  validatePlateNumber: function validatePlateNumber(rule, value, callback) {
    if (!value || value === '') {
      callback(new Error('请输入车牌号'));
    } else if (value.trim().replace(/\*|\?/g, '').length === 0) {
      // 车牌号必选
      callback(new Error('输入的车牌号中不能只包含通配符'));
    } else if (/^[京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼|使|领|A-Z|a-z|0-9|挂|学|警|港|澳|\\?|\\*]{1,}$/.test(value.trim()) === false) {
      callback(new Error('车牌号中包含非法字符'));
    } else {
      callback();
    }
  },
  validateOptionalPlateNumber: function validateOptionalPlateNumber(rule, value, callback) {
    // 车牌号可选
    if (!value || value === '') {
      callback();
    } else if (value.trim().replace(/\*|\?/g, '').length === 0) {
      callback(new Error('输入的车牌号中不能只包含通配符'));
    } else if (/^[京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼|使|领|A-Z|a-z|0-9|挂|学|警|港|澳|\\?|\\*]*$/.test(value.trim()) === false) {
      callback(new Error('车牌号中包含非法字符'));
    } else {
      callback();
    }
  },
  validateRealPlateNumber: function validateRealPlateNumber(rule, value, callback) {
    // 完整车牌号
    if (!value || value === '') {
      callback(new Error('请输入准确的车牌'));
    } else if (value.trim().indexOf('*') !== -1 || value.trim().indexOf('?') !== -1) {
      callback(new Error('输入的车牌号中不能包含通配符'));
    } else if (/^[京|津|沪|渝|冀|豫|云|辽|黑|湘|皖|鲁|新|苏|浙|赣|鄂|桂|甘|晋|蒙|陕|吉|闽|贵|粤|青|藏|川|宁|琼|使|领|A-Z|a-z|0-9|挂|学|警|港|澳|\\?|\\*]*$/.test(value.trim()) === false) {
      callback(new Error('车牌号中包含非法字符'));
    } else if (value.trim().length !== 7 && value.trim().length !== 8) {
      callback(new Error('车牌号长度应为7或8个字符'));
    } else {
      callback();
    }
  },
  validateTimeArea: function validateTimeArea(rule, value, callback) {
    if (Array.isArray(value) && value.length > 1 && value[0] && value[1]) {
      callback();
    } else {
      callback(new Error('请选择时间范围'));
    }
  },
  mapLocalization: function mapLocalization(Leaflet) {
    Leaflet.drawLocal.draw.toolbar.buttons.polygon = '画多边形';
    Leaflet.drawLocal.draw.toolbar.buttons.circle = '画圆形';
    Leaflet.drawLocal.draw.toolbar.buttons.rectangle = '画矩形';
    Leaflet.drawLocal.draw.toolbar.buttons.sector = '画扇形';
    Leaflet.drawLocal.draw.toolbar.actions.title = '取消';
    Leaflet.drawLocal.draw.toolbar.actions.text = '取消';
    Leaflet.drawLocal.draw.toolbar.finish.title = '完成';
    Leaflet.drawLocal.draw.toolbar.finish.text = '完成';
    Leaflet.drawLocal.draw.toolbar.undo.title = '删除最后一个点';
    Leaflet.drawLocal.draw.toolbar.undo.text = '删除最后一个点';

    Leaflet.drawLocal.draw.handlers.simpleshape.tooltip.end = '松开鼠标结束';
    Leaflet.drawLocal.draw.handlers.rectangle.tooltip.start = '点击并拖拽，画出一个矩形';
    Leaflet.drawLocal.draw.handlers.sector.tooltip.start = '点击并拖拽，画出一个扇形';
    Leaflet.drawLocal.draw.handlers.sector.radius = '半径';
    Leaflet.drawLocal.draw.handlers.circle.tooltip.start = '点击并拖拽，画出一个圆形';
    Leaflet.drawLocal.draw.handlers.circle.radius = '半径';
    Leaflet.drawLocal.draw.handlers.polygon.tooltip.start = '点击鼠标，开始绘制多边形';
    Leaflet.drawLocal.draw.handlers.polygon.tooltip.cont = '点击鼠标，继续绘制多边形';
    Leaflet.drawLocal.draw.handlers.polygon.tooltip.end = '点击第一个点，完成绘制';

    Leaflet.drawLocal.edit.toolbar.actions.save.title = '保存更改';
    Leaflet.drawLocal.edit.toolbar.actions.save.text = '保存';
    Leaflet.drawLocal.edit.toolbar.actions.cancel.title = '取消编辑，放弃所有更改';
    Leaflet.drawLocal.edit.toolbar.actions.cancel.text = '取消';
    Leaflet.drawLocal.edit.toolbar.actions.clearAll.title = '清除所有图形';
    Leaflet.drawLocal.edit.toolbar.actions.clearAll.text = '清空';

    Leaflet.drawLocal.edit.toolbar.buttons.edit = '编辑图形';
    Leaflet.drawLocal.edit.toolbar.buttons.editDisabled = '没有图形可编辑';
    Leaflet.drawLocal.edit.toolbar.buttons.remove = '删除图形';
    Leaflet.drawLocal.edit.toolbar.buttons.removeDisabled = '没有图形可删除';

    Leaflet.drawLocal.edit.handlers.edit.tooltip.text = '拖动图形上的控制点进行编辑';
    Leaflet.drawLocal.edit.handlers.edit.tooltip.subtext = '点击取消可撤销更改';
    Leaflet.drawLocal.edit.handlers.remove.tooltip.text = '点击要删除的图形';
  },
  toLogin: function toLogin() {
    location.href = '/login.html';
  },
  toHome: function toHome() {
    location.href = '/index.html';
  },
  toGuide: function toGuide() {
    location.href = '/guide.html';
  },
  pickerOptions: {
    shortcuts: [{
      text: '最近1天',
      onClick: function onClick(picker) {
        var end = new Date();
        var start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近7天',
      onClick: function onClick(picker) {
        var end = new Date();
        var start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '最近30天',
      onClick: function onClick(picker) {
        var end = new Date();
        var start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  },
  pickerOptions2: {
    shortcuts: [{
      text: '今后1天',
      onClick: function onClick(picker) {
        var end = new Date();
        var start = new Date();
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '今后7天',
      onClick: function onClick(picker) {
        var end = new Date();
        var start = new Date();
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 7);
        picker.$emit('pick', [start, end]);
      }
    }, {
      text: '今后30天',
      onClick: function onClick(picker) {
        var end = new Date();
        var start = new Date();
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 30);
        picker.$emit('pick', [start, end]);
      }
    }]
  },
  pickerOptions3: {
    shortcuts: [{
      text: '截止今天',
      onClick: function onClick(picker) {
        var end = new Date();
        var start = new Date();
        end.setHours(23);
        end.setMinutes(59);
        end.setSeconds(59);
        picker.$emit('pick', [start, end]);
      }
    }]
  },
  autoDraw: function autoDraw(selector) {
    setTimeout(function () {
      var element = $(selector)[0];
      element.click();
    }, 200);
  },
  getMovingDurations: function getMovingDurations(latlngs, speed) {
    speed = speed || 1;
    var durations = [];
    for (var i = 0, j = latlngs.length - 1; i < j; i++) {
      var distance = latlngs[i].distanceTo(latlngs[i + 1]);
      if (distance > 20000) {
        durations[i] = 2000 * speed;
      } else if (distance > 10000 && distance <= 20000) {
        durations[i] = 1600 * speed;
      } else if (distance > 5000 && distance <= 10000) {
        durations[i] = 1200 * speed;
      } else if (distance === 0) {
        durations[i] = 0;
      } else {
        durations[i] = 800 * speed;
      }
    }
    return durations;
  },

  vehicleKinds: {
    轿车: '轿车',
    商务车: '商务车',
    越野车: '越野车',
    皮卡车: '皮卡车',
    面包车: '面包车',
    小型客车: '小型客车',
    大型客车: '大型客车',
    小型货车: '小型货车',
    大型货车: '大型货车',
    重型货车: '重型货车',
    栏板卡车: '栏板卡车',
    厢式货车: '厢式货车',
    市政车: '市政车',
    工程运输车: '工程运输车',
    微型轿车: '微型轿车',
    校车: '校车',
    其他: '其他'
  },
  plateColors: {
    蓝色: '蓝',
    黄色: '黄',
    绿色: '绿',
    白色: '白',
    黑色: '黑'
  },
  vehicleColors: {
    黑色: '黑色',
    白色: '白色',
    红色: '红色',
    绿色: '绿色',
    青色: '青色',
    蓝色: '蓝色',
    黄色: '黄色',
    紫色: '紫色',
    深灰色: '深灰色',
    银灰色: '银灰色',
    棕色: '棕色',
    香槟金色: '香槟金色',
    粉色: '粉色',
    橙色: '橙色',
    其他: '其他'
  },
  cycleColors: {
    黑: '黑',
    白: '白',
    灰: '灰',
    红: '红',
    蓝: '蓝',
    黄: '黄',
    橙: '橙',
    棕: '棕',
    绿: '绿',
    紫: '紫',
    青: '青',
    粉: '粉',
    其他: '其他'
  },
  commonColors: {
    黑: '黑',
    白: '白',
    灰: '灰',
    红: '红',
    蓝: '蓝',
    黄: '黄',
    橙: '橙',
    棕: '棕',
    绿: '绿',
    紫: '紫',
    青: '青',
    粉: '粉',
    拼接色: '拼接色',
    混色: '混色',
    其他: '其他'
  },
  dressUpStyle: {
    长袖: '长袖',
    短袖: '短袖',
    其他: '其他'
  },
  dressDownStyle: {
    长裤: '长裤',
    短裤: '短裤',
    裙子: '裙子',
    其他: '其他'
  },
  commonStates: {
    true: '是',
    false: '否'
  },
  numberCyclists: {
    一人: '一人',
    两人: '两人',
    多人: '多人'
  },
  isHair: {
    有头发: '有头发',
    头发较少: '头发较少',
    不确定: '不确定'
  },
  captureAngles: {
    0: '电警',
    1: '卡口'
  },
  cycleTypes: {
    batterybike: '电动自行车',
    batterymotor: '电动摩托车',
    bike: '自行车',
    motorbike_withBumper: '摩托车-带保险杠',
    motorbike_withoutBumper: '摩托车-无保险杠',
    motor_light: '摩托车-轻型',
    // pedestrian: '行人',
    pedicab_withHood: '三轮车-有篷',
    pedicab_withoutHood: '三轮车-无篷',
    tail_bike: '自行车车尾',
    tail_motor_batterycar: '摩托车、电动车车尾',
    tail_tricycle: '三轮车车尾',
    three_wheeled_scooter: '三轮摩托车',
    car_head: '车头',
    car_tail: '车尾',
    nonveh_side: '非机动车-侧身',
    others: '其他'
  },
  pedestrianAgeLimits: {
    '少年': '少年',
    '青年': '青年',
    '中年': '中年',
    '老年': '老年',
    '其他': '其他'
  },
  pedestrianGenders: {
    '男': '男',
    '女': '女'
  },
  videoTaskAlgorithm: [{
    label: '车辆分析',
    value: '0',
    disabled: false,
    icon: 'icon-vehicle'
  }, {
    label: '非机动车分析',
    value: '1',
    disabled: false,
    icon: 'icon-zixingche'
  }, {
    label: '行人属性分析',
    value: '2',
    disabled: false,
    icon: 'icon-pedestrian'
    // , {
    //   label: '拥堵判别',
    //   value: '3',
    //   disabled: false,
    //   icon: 'icon-congestion'
    // }
    // {
    //   label: '警戒区域',
    //   value: '4',
    //   disabled: false,
    //   icon: 'icon-warningArea'
    // },
    // {
    //   label: '人脸检测',
    //   value: '5',
    //   disabled: false,
    //   icon: 'icon-face'
    // }
  }],
  searchModes: {
    '0': '文本检索',
    '1': '图像检索'
  },
  getTaskAlgorithmLabel: function getTaskAlgorithmLabel(name, result, data) {
    data = data || this.videoTaskAlgorithm;
    result = result || [];
    for (var i = 0, j = data.length; i < j; i++) {
      var item = data[i];
      if (item.value === name) {
        return result.concat(item.label);
      } else if (item.children) {
        var values = this.getTaskAlgorithmLabel(name, result.concat(item.label), item.children);
        if (values.length > 0) {
          return values;
        }
      }
    }
    return [];
  },
  getTaskAlgorithmIcon: function getTaskAlgorithmIcon(name, result, data) {
    data = data || this.videoTaskAlgorithm;
    result = result || [];
    for (var i = 0, j = data.length; i < j; i++) {
      var item = data[i];
      if (item.value === name) {
        return result.concat(item.icon);
      }
    }
    return [];
  }
};

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = getToken;
/* harmony export (immutable) */ __webpack_exports__["a"] = setToken;
/* harmony export (immutable) */ __webpack_exports__["c"] = removeToken;
/* harmony export (immutable) */ __webpack_exports__["d"] = getNickName;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_base64__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_base64___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_base64__);



var TokenKey = 'token';

function getToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get(TokenKey);
}

function setToken(token) {
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set(TokenKey, token);
  // let sub = JSON.parse(Base64.decode(token))
  var sub = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_js_base64__["Base64"].decode(token.split('.')[1]));
  // console.log(Base64.decode(token.split('.')[1]), sub)
  __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.set('NICKNAME', sub.nickName);
}

function removeToken() {
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.remove(TokenKey);
}

function getNickName() {
  console.log(__WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('NICKNAME'));
  return __WEBPACK_IMPORTED_MODULE_0_js_cookie___default.a.get('NICKNAME');
}

/***/ }),

/***/ 22:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__auth__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__commons___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__commons__);





console.log(window.$config.server);

var myheader = 'token';

// create an axios instance
var service = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
  baseURL:  true ? window.$config.server : 'http://localhost:9900',
  // baseURL: 'http://localhost:9091', // api的base_url
  //   baseURL: 'https://lock.pacargle.com', // api的base_url
  timeout: 5000 // request timeout
});

// request interceptor
service.interceptors.request.use(function (config) {
  // Do something before request is sent
  config.headers[myheader] = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth__["b" /* getToken */])(); // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
  return config;
}, function (error) {
  // Do something with request error
  console.log(error); // for debug
  __WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"].error({
    message: '请求超时!'
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(error);
});

// respone interceptor
service.interceptors.response.use(function (response) {
  /**
   * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
   * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
   */
  console.log(response);
  if (response.headers[myheader]) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth__["a" /* setToken */])(response.headers[myheader]);
  }
  var res = response.data;
  if (res.errcode !== '0x0000') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({
      message: res.errmsg,
      type: 'error',
      duration: 1 * 1000
    });
    // 0x0004:非法的token; 50012:其他客户端登录了;  50014:Token 过期了;
    if (res.errcode === '0x0004' && __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth__["b" /* getToken */])()) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__auth__["c" /* removeToken */])();
      __WEBPACK_IMPORTED_MODULE_2_element_ui__["MessageBox"].alert('你登陆时间已到期，可以取消继续留在该页面，或者重新登录', '确定登出', {
        confirmButtonText: '重新登录',
        callback: function callback(action) {
          __WEBPACK_IMPORTED_MODULE_4__commons___default.a.toLogin();
          // router.push({
          //   path: '/login'
          // })
        }
      });
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('error');
  } else {
    return response.data;
  }
}, function (error) {
  console.log('err' + error); // for debug
  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_element_ui__["Message"])({
    message: error.message,
    type: 'error',
    duration: 5 * 1000
  });
  return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = (service);

/***/ }),

/***/ 252:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 253:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"theme":"#1890ff"};

/***/ }),

/***/ 254:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 267:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(85);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5550a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(276);
function injectStyle (ssrContext) {
  __webpack_require__(254)
}
var normalizeComponent = __webpack_require__(16)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7e5550a2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e5550a2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 268:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__ = __webpack_require__(86);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_062cb36e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__ = __webpack_require__(274);
function injectStyle (ssrContext) {
  __webpack_require__(252)
}
var normalizeComponent = __webpack_require__(16)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Home_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_062cb36e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Home_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 269:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__ = __webpack_require__(87);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b27445ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__ = __webpack_require__(279);
var normalizeComponent = __webpack_require__(16)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LineChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b27445ce_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LineChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 270:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__ = __webpack_require__(88);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c40f54c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieChart_vue__ = __webpack_require__(278);
var normalizeComponent = __webpack_require__(16)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PieChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c40f54c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PieChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 271:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapChart_vue__ = __webpack_require__(89);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_025a1a81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapChart_vue__ = __webpack_require__(273);
var normalizeComponent = __webpack_require__(16)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mapChart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_025a1a81_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_mapChart_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ 273:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,style:({height:_vm.height,width:_vm.width})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 274:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasToken)?_c('div',{staticClass:"home-map"},[_c('v-header'),_vm._v(" "),_c('el-row',{staticStyle:{"height":"calc(100% - 65px)"}},[_c('el-col',{staticStyle:{"display":"inline-block","height":"100%"},attrs:{"span":5}},[_c('div',{staticClass:"page-panel",staticStyle:{"margin-top":"6px"}},[_c('div',{staticClass:"image-border image-border1"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border2"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border3"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border4"}),_vm._v(" "),_c('div',{staticClass:"chart-wrapper",staticStyle:{"height":"220px"}},[_c('v-pie-chart',{attrs:{"chart-data":_vm.total,"chart-title":'充电桩总数',"height":'100%'}})],1),_vm._v(" "),_c('el-form',{staticClass:"data-form",attrs:{"label-width":"50%"}},[_c('el-form-item',{attrs:{"label":"总收益"}},[_c('span',[_vm._v(_vm._s(_vm.totalData.inCome == null ? 0:_vm.totalData.inCome))]),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v("元")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"累计充电次数"}},[_c('span',[_vm._v(_vm._s(_vm.totalData.chargeNum == null ? 0:_vm.totalData.chargeNum))]),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v("次")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"累计电量"}},[_c('span',[_vm._v(_vm._s(_vm.totalData.elecNum == null ? 0:_vm.totalData.elecNum))]),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v("度")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"当前收益"}},[_c('span',[_vm._v(_vm._s(_vm.totalData.currentIncome == null ? 0:_vm.totalData.currentIncome))]),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v("元")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"page-panel",staticStyle:{"height":"calc(100% - 430px)"}},[_c('div',{staticClass:"image-border image-border1"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border2"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border3"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border4"}),_vm._v(" "),_c('div',{staticClass:"chart-wrapper",staticStyle:{"height":"50%"}},[(!_vm.totalLoading)?_c('v-line-chart',{attrs:{"chart-data":_vm.totalIncome,"chart-title":'总收益',"height":'100%',"mode":'quadraticOut'}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"chart-wrapper",staticStyle:{"height":"50%"}},[(!_vm.totalLoading)?_c('v-line-chart',{attrs:{"chart-data":_vm.totalParking,"chart-title":'累计总电量',"height":'100%'}}):_vm._e()],1)])]),_vm._v(" "),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":14}},[_c('div',{staticClass:"chart-wrapper",staticStyle:{"height":"70%","padding-top":"6px"}},[_c('v-map-chart',{attrs:{"chart-data":_vm.converData(_vm.mapData),"height":'100%'},on:{"parkChange":_vm.handleParkChange}})],1),_vm._v(" "),_c('el-row',{staticClass:"page-panel",staticStyle:{"height":"calc(30% - 20px)"}},[_c('div',{staticClass:"image-border image-border1"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border2"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border3"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border4"}),_vm._v(" "),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":12}},[_c('div',{staticClass:"chart-wrapper",staticStyle:{"height":"100%"}},[(_vm.currentVisible&&!_vm.singleLoading)?_c('v-line-chart',{attrs:{"chart-data":_vm.singleIncome,"location":_vm.currentPark.name,"chart-title":'收益',"height":'100%',"mode":'quadraticOut'}}):_vm._e()],1)]),_vm._v(" "),_c('el-col',{staticStyle:{"height":"100%"},attrs:{"span":12}},[_c('div',{staticClass:"chart-wrapper",staticStyle:{"height":"100%"}},[(_vm.currentVisible&&!_vm.singleLoading)?_c('v-line-chart',{attrs:{"chart-data":_vm.singleParking,"location":_vm.currentPark.name,"chart-title":'累计电量',"height":'100%'}}):_vm._e()],1)])],1)],1),_vm._v(" "),_c('el-col',{staticStyle:{"display":"inline-block","height":"100%"},attrs:{"span":5}},[_c('div',{staticClass:"page-panel",staticStyle:{"margin-top":"6px"}},[_c('div',{staticClass:"image-border image-border1"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border2"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border3"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border4"}),_vm._v(" "),_c('div',{staticClass:"chart-wrapper",staticStyle:{"height":"220px"}},[(_vm.currentVisible)?_c('v-pie-chart',{attrs:{"chart-data":_vm.single,"chart-title":_vm.currentPark.name,"height":'100%'}}):_vm._e()],1),_vm._v(" "),_c('el-form',{staticClass:"data-form",attrs:{"label-width":"50%"}},[_c('el-form-item',{attrs:{"label":"总收益"}},[_c('span',[_vm._v(_vm._s(_vm.currentSingleData.inCome == null ? 0:_vm.currentSingleData.inCome))]),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v("元")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"累计充电次数"}},[_c('span',[_vm._v(_vm._s(_vm.currentSingleData.chargeNum == null ? 0:_vm.currentSingleData.chargeNum))]),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v("次")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"累计电量"}},[_c('span',[_vm._v(_vm._s(_vm.currentSingleData.elecNum == null ? 0:_vm.currentSingleData.elecNum))]),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v("度")])]),_vm._v(" "),_c('el-form-item',{attrs:{"label":"当前收益"}},[_c('span',[_vm._v(_vm._s(_vm.currentSingleData.currentIncome == null ? 0:_vm.currentSingleData.currentIncome))]),_vm._v(" "),_c('span',{staticClass:"unit-label"},[_vm._v("元")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"status-panel page-panel"},[_c('div',{staticClass:"image-border image-border1"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border2"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border3"}),_vm._v(" "),_c('div',{staticClass:"image-border image-border4"}),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","padding":"10px"}},[_c('span',{staticClass:"status-label"},[_vm._v("状态")]),_vm._v(" "),_c('i',{class:_vm.currentSingleData.status ? 'icon iconfont icon-guzhang fault':'icon iconfont icon-zhengchang'})]),_vm._v(" "),_c('div',{staticStyle:{"width":"100%","padding":"10px"}},[_c('span',{staticClass:"status-label"},[_vm._v("故障")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"22px"}},[_vm._v(_vm._s(_vm.currentSingleData.status?_vm.currentSingleData.fault:'无'))])]),_vm._v(" "),_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.voiceLoaded),expression:"!voiceLoaded"}],staticClass:"media-container",attrs:{"id":"ui-talk"}},[_c('div',{staticStyle:{"width":"100%","height":"100%"},attrs:{"id":"video-container"}})])])])],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 275:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 276:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-container"},[_c('h1',[_vm._v(_vm._s(_vm.config.title))]),_vm._v(" "),_c('el-dropdown',{staticClass:"login-user"},[_c('span',[_vm._v(_vm._s(_vm.loginUser))]),_vm._v(" "),_c('el-dropdown-menu',{attrs:{"slot":"dropdown"},slot:"dropdown"},[_c('el-dropdown-item',[_c('span',{on:{"click":_vm.about}},[_vm._v("关于")])]),_vm._v(" "),_c('el-dropdown-item',{attrs:{"divided":""}},[_c('span',{on:{"click":_vm.logout}},[_vm._v("退出")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"clock"},[_c('span',{staticClass:"clock-date"},[_vm._v(_vm._s(_vm.clock.date))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"clock-time"},[_vm._v(_vm._s(_vm.clock.time))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 278:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,style:({height:_vm.height,width:_vm.width})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 279:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.className,style:({height:_vm.height,width:_vm.width})})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ 37:
/***/ (function(module, exports) {

module.exports = {
  formatDate: function formatDate(date, fmt) {
    if (date instanceof Date === false) {
      return '';
    }
    fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
    var o = {
      'M+': date.getMonth() + 1, // 月份
      'd+': date.getDate(), // 日
      'h+': date.getHours(), // 小时
      'm+': date.getMinutes(), // 分
      's+': date.getSeconds(), // 秒
      'q+': Math.floor((date.getMonth() + 3) / 3), // 季度
      'S': date.getMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
    return fmt;
  },
  formatUTCDate: function formatUTCDate(date, fmt) {
    if (date instanceof Date === false) {
      return '';
    }
    fmt = fmt || 'yyyy-MM-dd hh:mm:ss';
    var o = {
      'M+': date.getUTCMonth() + 1, // 月份
      'd+': date.getUTCDate(), // 日
      'h+': date.getUTCHours(), // 小时
      'm+': date.getUTCMinutes(), // 分
      's+': date.getUTCSeconds(), // 秒
      'q+': Math.floor((date.getUTCMonth() + 3) / 3), // 季度
      'S': date.getUTCMilliseconds() // 毫秒
    };
    if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (date.getUTCFullYear() + '').substr(4 - RegExp.$1.length));
    for (var k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
    }
    return fmt;
  },
  submitForm: function submitForm(params, options) {
    var method = options.method;
    var action = options.action;
    var target = options.target;
    var form1 = document.createElement('form');
    form1.target = target;
    for (var i = 0; i < params.length; i++) {
      var param = params[i];
      var input = document.createElement('input');
      input.name = param.name;
      input.value = param.value;
      form1.appendChild(input);
    }
    document.body.appendChild(form1);
    form1.method = method;
    form1.action = action;
    form1.submit();
    document.body.removeChild(form1);
  },
  getQueryStrings: function getQueryStrings() {
    var result = {};
    var search = window.location.search.substr(1);
    var pairs = search.split('&');
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      var kv = pair.split('=');
      if (kv.length === 2) {
        kv[1] = kv[1] ? kv[1].replace(/\+/g, '%20') : kv[1];
        result[kv[0]] = decodeURIComponent(kv[1]);
      }
    }
    return result;
  },
  getQueryString: function getQueryString(name) {
    var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
    var r = window.location.search.substr(1).match(reg);
    if (r !== null) {
      r[2] = r[2] ? r[2].replace(/\+/g, '%20') : r[2];
      return decodeURIComponent(r[2]);
    } else {
      return null;
    }
  },
  getUrlFilename: function getUrlFilename(url) {
    var u = new URL(url);
    var index = u.pathname.lastIndexOf('/');
    if (index !== -1) {
      return u.pathname.substring(index + 1);
    } else {
      return u.pathname;
    }
  },
  parseParameters: function parseParameters(str, splitchar) {
    var result = {};
    splitchar = splitchar || '&';
    var pairs = str.split(splitchar);
    for (var i = 0; i < pairs.length; i++) {
      var pair = pairs[i];
      var kv = pair.split('=');
      if (kv.length === 2) {
        kv[1] = kv[1] ? kv[1].replace(/\+/g, '%20') : kv[1];
        result[kv[0]] = decodeURIComponent(kv[1]);
      }
    }
    return result;
  },
  clipImage: function clipImage(imgElement, sx, sy, swidth, sheight, x, y, width, height, callback) {
    if (!imgElement) {
      return;
    }
    var cav = document.createElement('canvas');
    cav.width = width;
    cav.height = height;
    var ctx = cav.getContext('2d');
    var img = new Image();
    img.setAttribute('crossOrigin', 'anonymous');
    img.onload = function () {
      ctx.drawImage(img, sx, sy, swidth, sheight, x, y, width, height);
      callback(cav.toDataURL('image/png'));
    };
    img.src = imgElement.src;
    // if (imgElement.complete) {
    //   ctx.drawImage(imgElement, sx, sy, swidth, sheight, x, y, width, height)
    //   callback(cav.toDataURL('image/png'))
    // } else {
    //   imgElement.onload = function () {
    //     ctx.drawImage(imgElement, sx, sy, swidth, sheight, x, y, width, height)
    //     callback(cav.toDataURL('image/png'))
    //   }
    // }
  },
  nextSibling: function nextSibling(node) {
    var tempLast = node.parentNode.lastChild;
    if (node === tempLast) return null;
    var tempObj = node.nextSibling;
    while (tempObj.nodeType !== 1 && tempObj.nextSibling != null) {
      tempObj = tempObj.nextSibling;
    }
    return tempObj.nodeType === 1 ? tempObj : null;
  },
  prevSibling: function prevSibling(node) {
    var tempFirst = node.parentNode.firstChild;
    if (node === tempFirst) return null;
    var tempObj = node.previousSibling;
    while (tempObj.nodeType !== 1 && tempObj.previousSibling != null) {
      tempObj = tempObj.previousSibling;
    }
    return tempObj.nodeType === 1 ? tempObj : null;
  },
  gotolink: function gotolink(href, target) {
    var a = document.createElement('a');
    a.href = href;
    a.target = target;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  },
  loadScript: function loadScript(url, id, callback, keep) {
    callback = callback || function () {};
    if (id && document.getElementById(id) !== null) {
      var scriptElement = document.getElementById(id);
      var loaded = scriptElement.getAttribute('complete') === 'true';
      if (loaded) {
        callback();
      } else {
        if (navigator.userAgent.indexOf('MSIE') > 0) {
          var readystatechangeFn = function readystatechangeFn() {
            if (this.readyState === 'loaded' || this.readyState === 'complete') {
              callback();
            }
            scriptElement.removeEventListener('readystatechange', readystatechangeFn);
          };
          scriptElement.addEventListener('readystatechange', readystatechangeFn);
        } else {
          var loadedFn = function loadedFn() {
            callback();
            scriptElement.removeEventListener('load', loadedFn);
          };
          scriptElement.addEventListener('load', loadedFn);
        }
      }
    } else {
      var domScript = document.createElement('script');
      domScript.id = id;
      domScript.src = url;
      if (navigator.userAgent.indexOf('MSIE') > 0) {
        domScript.onreadystatechange = function () {
          if (this.readyState === 'loaded' || this.readyState === 'complete') {
            domScript.setAttribute('complete', true);
            callback();
            this.onload = this.onreadystatechange = null;
            if (keep === false) {
              this.parentNode.removeChild(this);
            }
          }
        };
      } else {
        domScript.onload = function () {
          domScript.setAttribute('complete', true);
          callback();
          this.onload = this.onreadystatechange = null;
          if (keep === false) {
            this.parentNode.removeChild(this);
          }
        };
      }
      document.getElementsByTagName('head')[0].appendChild(domScript);
    }
  },
  loadCss: function loadCss(cssUrl, id) {
    if (id && document.getElementById(id) !== null) {
      return;
    }
    var source = document.createElement('link');
    source.id = id;
    source.rel = 'stylesheet';
    source.href = cssUrl;
    document.body.appendChild(source);
  },
  stopPropagation: function stopPropagation(e) {
    if (e.stopPropagation) {
      e.stopPropagation();
    } else {
      e.cancelBubble = true;
    }
  },
  downloadLink: function downloadLink(link, target) {
    var aElement = document.createElement('a');
    aElement.href = link;
    aElement.target = target;
    document.body.appendChild(aElement);
    aElement.click();
    document.body.removeChild(aElement);
  },
  downloadImage: function downloadImage(url) {
    var aElement = document.createElement('a');
    aElement.href = url;
    aElement.target = '_blank';
    aElement.download = this.getUrlFilename(url);
    document.body.appendChild(aElement);
    aElement.click();
    document.body.removeChild(aElement);
  },
  downloadCrossImage: function downloadCrossImage(url, name) {
    var _this = this;

    fetch(url, {
      credentials: 'same-origin'
    }).then(function (response) {
      return response.blob();
    }).then(function (blob) {
      var objectUrl = window.URL.createObjectURL(blob);
      var aElement = document.createElement('a');
      aElement.href = objectUrl;
      aElement.target = '_blank';
      aElement.download = name || _this.getUrlFilename(url.match(/target=([^?&]+)/)[1]);
      document.body.appendChild(aElement);
      aElement.click();
      document.body.removeChild(aElement);
    }).catch(function (err) {
      console.error(err);
    });
  },
  download: function download(data, filename) {
    var blob = new Blob([data], { type: 'application/tar+gzip' });
    var element = document.createElement('a');
    if ('download' in element) {
      // 非IE下载
      element.download = filename;
      element.style.display = 'none';
      element.href = URL.createObjectURL(blob);
      document.body.appendChild(element);
      element.click();
      URL.revokeObjectURL(element.href); // 释放URL对象
      document.body.removeChild(element);
    } else {
      // IE10+下载
      navigator.msSaveBlob(blob, filename);
    }
  },
  playSound: function playSound(src) {
    var borswer = window.navigator.userAgent.toLowerCase();
    if (borswer.indexOf('ie') >= 0) {
      // IE内核浏览器
      var embedElement = document.createElement('embed');
      embedElement.id = 'soundPlayer';
      embedElement.src = src;
      embedElement.hidden = true;
      embedElement.autostart = true;
      embedElement.loop = false;
      if (!document.getElementById('soundPlayer')) {
        document.body.appendChild(embedElement);
      }
      var embed = document.getElementById('soundPlayer');
      // 浏览器不支持 audion，则使用 embed 播放
      embed.volume = 100;
      // embed.play() // 这个不需要
    } else {
      // 非IE内核浏览器
      var audioElement = document.createElement('audio');
      audioElement.id = 'soundPlayer';
      audioElement.src = src;
      audioElement.hidden = true;
      if (!document.getElementById('soundPlayer')) {
        document.body.appendChild(audioElement);
      }
      var audio = document.getElementById('soundPlayer');
      // 浏览器支持 audion
      audio.play();
    }
  },
  getBase64Image: function getBase64Image(img) {
    var canvas = document.createElement('canvas');
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    var dataURL = canvas.toDataURL('image/png');
    return dataURL;
  },
  dataURLToBlob: function dataURLToBlob(dataURL) {
    var arr = dataURL.split(',');
    var matches = arr[0].match(/:(.*?);/);
    var mime = matches ? matches[1] : 'image/png';
    var bstr = atob(arr[1]);
    var len = bstr.length;
    var u8arr = new Uint8Array(len);
    while (len--) {
      u8arr[len] = bstr.charCodeAt(len);
    }
    return new Blob([u8arr], { type: mime });
  },
  getBlobImage: function getBlobImage(img) {
    var dataURL = this.getBase64Image(img);
    var blob = this.dataURLToBlob(dataURL);
    return blob;
  },
  getImageBounds: function getImageBounds(url, callback) {
    callback = callback || function () {};
    var img = document.createElement('img');
    img.src = url;
    img.style.display = 'none';
    img.onload = function () {
      callback(null, img.naturalHeight, img.naturalWidth);
      document.body.removeChild(img);
    };
    img.onerror = function (err) {
      console.error(err);
      callback(err);
      document.body.removeChild(img);
    };
    document.body.appendChild(img);
  },
  randomStr: function randomStr(len) {
    var result = '';
    var seed = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'm', 'n', 'p', 'Q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    var seedlength = seed.length;
    for (var i = 0; i < len; i++) {
      var j = Math.floor(Math.random() * seedlength);
      result += seed[j];
    }
    return result;
  },
  getSiteTitle: function getSiteTitle() {
    var title = '管理平台';
    return title;
  },
  openLink: function openLink(url, target) {
    var ele = document.createElement('a');
    document.body.appendChild(ele);
    ele.href = url;
    ele.target = target;
    ele.click();
    document.body.removeChild(ele);
  },

  loadScripts: function loadScripts(scripts, callback) {
    var _this2 = this;

    var item = scripts[0];
    if (item) {
      this.loadScript(item.url, item.id, function () {
        _this2.loadScripts(scripts.slice(1), callback);
      }, item.keep);
    } else if (callback) {
      callback();
    }
  },
  getImageDataFromUrl: function getImageDataFromUrl(url, callback) {
    var img = new Image();
    img.setAttribute('crossOrigin', 'Anonymous');
    img.onload = function (a) {
      var canvas = document.createElement('canvas');
      canvas.width = this.width;
      canvas.height = this.height;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(this, 0, 0);
      var dataURI = canvas.toDataURL('image/jpg');
      // convert base64/URLEncoded data component to raw binary data held in a string
      var byteString;
      if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
      } else {
        byteString = unescape(dataURI.split(',')[1]);
      }
      // separate out the mime component
      var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
      // write the bytes of the string to a typed array
      var ia = new Uint8Array(byteString.length);
      for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }
      return callback(new Blob([ia], { type: mimeString }));
    };
    img.src = url;
  }
};

/***/ }),

/***/ 85:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_auth__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_logout_js__ = __webpack_require__(172);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global $config */


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      clock: {
        date: '',
        time: ''
      },
      config: $config
    };
  },

  computed: {
    loginUser: function loginUser() {
      return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["d" /* getNickName */])();
    }
  },
  mounted: function mounted() {
    this.startClock();
  },

  methods: {
    loadClock: function loadClock() {
      var week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
      var cd = new Date();
      this.clock.time = zeroPadding(cd.getHours(), 2) + ':' + zeroPadding(cd.getMinutes(), 2) + ':' + zeroPadding(cd.getSeconds(), 2);
      this.clock.date = zeroPadding(cd.getFullYear(), 4) + '/' + zeroPadding(cd.getMonth() + 1, 2) + '/' + zeroPadding(cd.getDate(), 2) + ' ' + week[cd.getDay()];
    },
    startClock: function startClock() {
      this.loadClock();
      setInterval(this.loadClock, 1000);
    },
    logout: function logout() {
      var _this = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__api_logout_js__["a" /* logout */])().then(function (resp) {
        if (resp.errmsg === 'ok') {
          __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_auth__["c" /* removeToken */])();
          _this.$commons.toLogin();
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    about: function about() {
      var version = '1.0';
      this.$alert('\u7248\u672C ' + version, '\u5173\u4E8E' + this.config.title, {
        confirmButtonText: '确定'
      });
    }
  }
});
function zeroPadding(num, digit) {
  var zero = '';
  for (var i = 0; i < digit; i++) {
    zero += '0';
  }
  return (zero + num).slice(-digit);
}

/***/ }),

/***/ 86:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils_auth__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_parkInfo__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Header_vue__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PieChart__ = __webpack_require__(270);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LineChart__ = __webpack_require__(269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__mapChart__ = __webpack_require__(271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_monitorInfo__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_lcChargerLog__ = __webpack_require__(170);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* global EZUIKit , $config */


 // getparkNum, getparkIncome






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'home',
  data: function data() {
    return {
      hasToken: false,
      // totalParkNum: {},
      // singleParkNum: {},
      totalNum: {},
      totalDayNum: {},
      totalSevenDaysNum: [],
      singleNum: {},
      singleDayNum: {},
      singleSevenDaysNum: [],
      totalLoading: false,
      totalIncome: [],
      totalParking: [],
      totalParkIncome: {},
      singleLoading: false,
      singleIncome: [],
      singleParking: [],
      singleParkIncome: {},
      currentPark: {},
      currentVisible: false,
      mapData: [],
      playerInstance: null,
      ezuikitTalkData: {},
      voiceLoaded: false,
      voiceWidth: '',
      voiceHeight: '',
      parkfieldId: '',
      minitorInfo: {}
    };
  },

  components: { vHeader: __WEBPACK_IMPORTED_MODULE_4__Header_vue__["a" /* default */], vPieChart: __WEBPACK_IMPORTED_MODULE_5__PieChart__["a" /* default */], vLineChart: __WEBPACK_IMPORTED_MODULE_6__LineChart__["a" /* default */], vMapChart: __WEBPACK_IMPORTED_MODULE_7__mapChart__["a" /* default */] }, // , vVoice
  mounted: function mounted() {
    if (!localStorage.accessToken || localStorage.accessToken === '' || typeof localStorage.accessToken === 'undefined') {
      this.getAccessToken();
    }
    this.$nextTick(function () {
      if (!__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__utils_auth__["b" /* getToken */])()) {
        this.hasToken = false;
        this.$commons.toLogin();
      } else {
        this.hasToken = true;
        this.getParkInfo();
        this.$nextTick(function () {});
      }
    });
  },
  computed: {
    total: function total() {
      var data = [];
      // data.push({ value: this.totalParkNum['bigSpaceTotal'], name: '使用' })
      // data.push({ value: this.totalParkNum['smallSpaceTotal'], name: '空闲' })
      data.push({ value: this.totalNum['usedCharger'], name: '占用' });
      data.push({ value: this.totalNum['freeCharger'], name: '空闲' });
      return data;
    },
    totalData: function totalData() {
      var data = {};
      // data.income = this.totalParkNum['feeTotal']
      // data.currentIncome = this.totalParkNum['feeCurrent']
      // data.todayParking = this.totalParkNum['parknumTotal']
      // data.remain = this.totalParkNum['bigSpaceRemaining'] + this.totalParkNum['smallSpaceRemaining']
      data.inCome = this.totalNum['inCome'];
      data.chargeNum = this.totalNum['chargeNum'];
      data.elecNum = this.totalNum['elecNum'];
      data.currentIncome = this.totalDayNum['inCome'];
      return data;
    },
    single: function single() {
      var data = [];
      // data.push({ value: this.singleParkNum['bigSpaceTotal'], name: '使用' })
      // data.push({ value: this.singleParkNum['smallSpaceTotal'], name: '空闲' })
      data.push({ value: this.singleNum['usedCharger'], name: '占用' });
      data.push({ value: this.singleNum['freeCharger'], name: '空闲' });
      return data;
    },
    currentSingleData: function currentSingleData() {
      [];
      var data = {};
      // data.currentIncome = this.singleParkNum['feeCurrent']
      // data.todayParking = this.singleParkNum['parknumTotal']
      // data.remain = {
      //   small: this.singleParkNum['smallSpaceRemaining'],
      //   large: this.singleParkNum['bigSpaceRemaining']
      // }
      // data.status = this.singleParkNum['parkStatus'] ? 1 : 0
      // data.fault = this.singleParkNum['parkStatus'] ? this.singleParkNum['parkStatus'] : '无'
      data.inCome = this.singleNum['inCome'];
      data.chargeNum = this.singleNum['chargeNum'];
      data.elecNum = this.singleNum['elecNum'];
      data.currentIncome = this.singleDayNum['inCome'];
      return data;
    }
  },
  methods: {
    converData: function converData(data) {
      console.log(data);
      var res = [];
      for (var i = 0; i < data.length; i++) {
        res.push({
          name: data[i].name,
          value: [data[i].longitude, data[i].latitude, data[i]['id']]
        });
      }
      return res;
    },
    handleParkChange: function handleParkChange(index, id) {
      console.log('handleParkChange:' + id);
      if (id) {
        if (this.currentPark.id !== id) {
          this.currentPark = this.mapData[index];
          // this.updateParkNum()
          // this.updateParkIncome()
          this.getStatisticsInfo(id);
          this.getStatisticsInfo1day(id);
          this.getInfo7days(id);
          // document.getElementById('ui-talk').innerHTML = ''
          document.getElementById('video-container').remove();
          var containerDiv = document.createElement('div');
          containerDiv.id = 'video-container';
          containerDiv.style.width = '100%';
          containerDiv.style.height = '100%';
          document.getElementById('ui-talk').appendChild(containerDiv);
          this.play(id);
        }
      }
    },

    // initPlayer () {
    //   this.voiceWidth = document.getElementById('ui-talk').clientWidth
    //   this.voiceHeight = document.getElementById('ui-talk').clientHeight
    //   this.playerInstance = new EZUIKit.EZUIKitPlayer({
    //     autoplay: true,
    //     id: 'video-container',
    //     accessToken: localStorage.accessToken,
    //     url: '',
    //     template: 'voice', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
    //     width: this.voiceWidth,
    //     height: this.voiceWidth * 9 / 16
    //   })
    //   this.voiceLoaded = true
    // },
    initTalkPlayer: function initTalkPlayer(id) {
      console.log('initTalkPlayer');
      console.log(this.minitorInfo);
      var url;
      url = this.minitorInfo.url;
      console.log(url);
      console.log(localStorage.accessToken);
      this.voiceWidth = document.getElementById('ui-talk').clientWidth;
      this.voiceHeight = document.getElementById('ui-talk').clientHeight;
      this.playerInstance = new EZUIKit.EZUIKitPlayer({
        autoplay: true,
        id: 'video-container',
        accessToken: localStorage.accessToken,
        url: url,
        template: 'voice', // simple - 极简版;standard-标准版;security - 安防版(预览回放);voice-语音版；
        width: this.voiceWidth,
        height: this.voiceWidth * 9 / 16
      });
      this.voiceLoaded = true;
    },
    play: function play(id) {
      var _this = this;

      var params = new FormData();
      if (id) {
        console.log(id);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_monitorInfo__["a" /* getMonitorInfo */])(id).then(function (resp) {
          if (resp.errmsg === 'ok') {
            _this.minitorInfo = resp.data[0];
            params.append('accessToken', localStorage.accessToken);
            params.append('source', resp.data.source);
          }
        }).catch(function (e) {
          console.log(e);
        });
      } else {
        params.append('accessToken', localStorage.accessToken);
        params.append('source', $config.source);
      }
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://open.ys7.com/api/lapp/live/video/open', params, {
        timeout: 5000
      }).then(function (res) {
        if (res.data.code === '10002') {
          _this.getAccessToken(function (id) {
            _this.play(id);
          });
        } else {
          _this.getAddress(id);
          setTimeout(function () {
            // this.initPlayer()
            _this.initTalkPlayer(id);
          }, 2500);
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getAccessToken: function getAccessToken(id, callback) {
      var _this2 = this;

      callback = callback || function () {};
      var params = new FormData();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_monitorInfo__["a" /* getMonitorInfo */])(id).then(function (resp) {
        if (resp.errmsg === 'ok') {
          _this2.minitorInfo = resp.data[0];
          params.append('appKey', resp.data[0].appkey);
          params.append('appSecret', resp.data[0].secret);
        }
        console.log(resp);
        console.log(_this2.minitorInfo);
        console.log(resp.data[0].appkey);
        console.log(resp.data[0].secret);
        console.log(_this2.$route.params);
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://open.ys7.com/api/lapp/token/get', params, {
          timeout: 5000
        });
      }).then(function (res) {
        if (res.data) {
          console.log(res.data.data.accessToken);
          localStorage.setItem('accessToken', res.data.data.accessToken);
          callback();
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getAddress: function getAddress(id) {
      var _this3 = this;

      var params = new FormData();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__api_monitorInfo__["a" /* getMonitorInfo */])(id).then(function (resp) {
        if (resp.errmsg === 'ok') {
          _this3.minitorInfo = resp.data[0];
          params.append('accessToken', localStorage.accessToken);
          params.append('source', resp.data.source);
        }
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://open.ys7.com/api/lapp/live/address/get', params, {
          timeout: 5000
        });
      }).then(function (res) {
        console.log(res);
      }).catch(function (e) {
        console.log(e);
      });
    },
    closeChannel: function closeChannel(callback) {
      callback = callback || function () {};
      var params = new FormData();
      params.append('accessToken', localStorage.accessToken);
      params.append('source', this.minitorInfo.source);
      return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post('https://open.ys7.com/api/lapp/live/video/close', params, {
        timeout: 5000
      }).then(function (res) {
        console.log(res);
        callback();
      }).catch(function (e) {
        console.log(e);
      });
    },
    handleRestart: function handleRestart() {
      var _this4 = this;

      this.closeChannel(function () {
        _this4.$refs.voiceVideo.init();
      });
    },
    getParkInfo: function getParkInfo() {
      var _this5 = this;

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_parkInfo__["a" /* getparkList */])().then(function (resp) {
        if (resp.errmsg === 'ok') {
          _this5.getStatisticsInfo(_this5.parkfieldId);
          _this5.getStatisticsInfo1day(_this5.parkfieldId);
          _this5.getInfo7days(_this5.parkfieldId);
          _this5.getCharageStatus(_this5.parkfieldId);
          _this5.mapData = resp.data;
          console.log(_this5.mapData);
          console.log(_this5.mapData[0].id);
          _this5.parkfieldId = _this5.mapData[0].id;
          console.log(_this5.parkfieldId);
          console.log(_this5.currentPark);
          _this5.getStatisticsInfo(_this5.parkfieldId);
          _this5.getStatisticsInfo1day(_this5.parkfieldId);
          _this5.getInfo7days(_this5.parkfieldId);
          _this5.getCharageStatus(_this5.parkfieldId);
          _this5.getAccessToken(_this5.parkfieldId);
          _this5.play(_this5.parkfieldId);
          _this5.currentPark = _this5.mapData[0];
          _this5.currentVisible = true;
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    getStatisticsInfo: function getStatisticsInfo(parkfieldId) {
      var _this6 = this;

      // 实时历史数据更新
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__api_lcChargerLog__["a" /* getStatisticsInfo */])(parkfieldId).then(function (resp) {
        if (resp.errmsg === 'ok') {
          if (parkfieldId == null || parkfieldId === '') {
            _this6.totalNum = resp.data;
          } else {
            _this6.singleNum = resp.data;
          }
          console.log('totalNum:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this6.totalNum));
          console.log('singleNum:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this6.singleNum));
        }
      });
    },
    getStatisticsInfo1day: function getStatisticsInfo1day(parkfieldId) {
      var _this7 = this;

      // 实时当天数据更新
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__api_lcChargerLog__["b" /* getStatisticsInfo1day */])(parkfieldId).then(function (resp) {
        if (resp.errmsg === 'ok') {
          if (parkfieldId == null || parkfieldId === '') {
            _this7.totalDayNum = resp.data;
          } else {
            _this7.singleDayNum = resp.data;
          }
          console.log('totalDayNum:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this7.totalDayNum));
          console.log('singleDayNum:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this7.singleDayNum));
        }
      });
    },
    getInfo7days: function getInfo7days(parkfieldId) {
      var _this8 = this;

      // 获取7天统计数据信息
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__api_lcChargerLog__["c" /* getInfo7days */])(parkfieldId).then(function (resp) {
        if (resp.errmsg === 'ok') {
          if (parkfieldId == null || parkfieldId === '') {
            _this8.totalSevenDaysNum = resp.data;
            for (var i = 0; i < _this8.totalSevenDaysNum.length; i++) {
              _this8.totalIncome.push(_this8.totalSevenDaysNum[i].inCome == null ? 0 : _this8.totalSevenDaysNum[i].inCome);
            }
            for (i = 0; i < _this8.totalSevenDaysNum.length; i++) {
              _this8.totalParking.push(_this8.totalSevenDaysNum[i].elecNum == null ? 0 : _this8.totalSevenDaysNum[i].elecNum);
            }
          } else {
            _this8.singleSevenDaysNum = resp.data;
            for (i = 0; i < _this8.singleSevenDaysNum.length; i++) {
              _this8.singleIncome.push(_this8.singleSevenDaysNum[i].inCome == null ? 0 : _this8.singleSevenDaysNum[i].inCome);
            }
            for (i = 0; i < _this8.singleSevenDaysNum.length; i++) {
              _this8.singleParking.push(_this8.singleSevenDaysNum[i].elecNum == null ? 0 : _this8.singleSevenDaysNum[i].elecNum);
            }
          }
          console.log('singleSevenDaysNum:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.totalSevenDaysNum));
          console.log('singleDayNum:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.singleSevenDaysNum));
          console.log('totalIncome:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.totalIncome));
          console.log('totalParking:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.totalParking));
          console.log('singleIncome:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.singleIncome));
          console.log('singleParking:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this8.singleParking));
        }
      });
    },
    getCharageStatus: function getCharageStatus(parkfieldId) {
      var _this9 = this;

      // 空闲，使用
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__api_parkInfo__["b" /* getCharageStatus */])(parkfieldId).then(function (resp) {
        if (resp.errmsg === 'ok') {
          if (parkfieldId == null || parkfieldId === '') {
            _this9.totalNum.usedCharger = resp.data.usedCharger;
            _this9.totalNum.freeCharger = resp.data.freeCharger;
          } else {
            _this9.singleNum.usedCharger = resp.data.usedCharger;
            _this9.singleNum.freeCharger = resp.data.freeCharger;
          }
          console.log('freeCharger:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.totalNum.freeCharger));
          console.log('usedCharger:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.totalNum.usedCharger));
          console.log('freeCharger:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.singleNum.freeCharger));
          console.log('usedCharger:' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this9.singleNum.usedCharger));
        }
      });
    }
    // startUpdateParkNum () {
    //   setTimeout(() => {
    //     this.updateParkNum(() => {
    //       this.startUpdateParkNum()
    //     })
    //   }, 60000)
    // },
    // updateParkNum (callback) {
    //   callback = callback || function () { }
    //   getparkNum(0).then(resp => {
    //     if (resp.errmsg === 'ok') {
    //       this.totalParkNum = resp.data[0]
    //     }
    //     return getparkNum(this.currentPark.id)
    //   })
    //     .then(resp => {
    //       console.log(resp)
    //       if (resp.errmsg === 'ok') {
    //         this.singleParkNum = resp.data[0]
    //       }
    //       callback()
    //     })
    //     .catch(e => {
    //       console.log(e)
    //       callback()
    //     })
    // },
    // startUpdateParkIncome () {
    //   var date = new Date()
    //   var timeStamp = new Date(new Date().setHours(0, 0, 0, 0) + 86400 * 1000)
    //   var timer = timeStamp - date
    //   setTimeout(() => {
    //     this.updateParkIncome(() => {
    //       this.startUpdateParkIncome()
    //     })
    //   }, timer)
    // },
    // updateParkIncome (callback) {
    //   callback = callback || function () { }
    //   this.totalLoading = true
    //   this.singleLoading = true
    //   getparkIncome(0).then(resp => {
    //     if (resp.errmsg === 'ok') {
    //       this.totalParkIncome = resp.data[0]
    //       this.totalIncome = this.totalParkIncome['parkIncome'].split(',')
    //       this.totalParking = this.totalParkIncome['parkNum'].split(',')
    //       this.totalLoading = false
    //     }
    //     return getparkIncome(this.currentPark.id)
    //   })
    //     .then(resp => {
    //       if (resp.errmsg === 'ok') {
    //         this.singleParkIncome = resp.data[0]
    //         this.singleIncome = this.singleParkIncome['parkIncome'].split(',')
    //         this.singleParking = this.singleParkIncome['parkNum'].split(',')
    //         this.singleLoading = false
    //       }
    //       callback()
    //     })
    //     .catch(e => {
    //       this.totalLoading = false
    //       this.singleLoading = false
    //       callback()
    //       console.log(e)
    //     })
    // }

  },
  deactivated: function deactivated() {
    this.closeChannel();
  },
  beforeDestroy: function beforeDestroy() {
    this.closeChannel();
  }
});

/***/ }),

/***/ 87:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//

/* global echarts */
// require('echarts/theme/macarons') // echarts theme
// import resize from './mixins/resize'

/* harmony default export */ __webpack_exports__["a"] = ({
  // mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    location: {
      type: String,
      default: ''
    },
    chartTitle: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '350px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Array,
      required: true
    },
    mode: {
      type: String,
      default: 'cubicInOut'
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },

  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initChart();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },

  methods: {
    initChart: function initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions(this.chartData);
    },
    setOptions: function setOptions(expectedData) {
      var series = [];
      if (this.mode === 'quadraticOut') {
        series.push({
          name: this.chartTitle,
          smooth: true,
          type: 'line',
          itemStyle: {
            normal: {
              color: '#3888fa',
              lineStyle: {
                color: '#3888fa',
                width: 2
              },
              areaStyle: {
                color: 'rgba(64,158,255,0.3)'
              }
            }
          },
          data: expectedData,
          animationDuration: 2800,
          animationEasing: 'quadraticOut'
        });
      } else {
        series.push({
          name: this.chartTitle,
          itemStyle: {
            normal: {
              color: '#FF005A',
              lineStyle: {
                color: '#FF005A',
                width: 2
              }
            }
          },
          smooth: true,
          type: 'line',
          data: expectedData,
          animationDuration: 2800,
          animationEasing: 'cubicInOut'
        });
      }
      this.chart.setOption({
        title: {
          text: this.location + ' 近7天' + this.chartTitle,
          left: 'center',
          top: 5,
          textStyle: {
            color: '#ccc'
          }
        },
        xAxis: {
          data: ['1', '2', '3', '4', '5', '6', '7'],
          boundaryGap: false,
          axisTick: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          }

        },
        grid: {
          left: 10,
          right: 10,
          bottom: 20,
          top: 50,
          containLabel: true
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross'
          },
          padding: [5, 10]
        },
        yAxis: {
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          },
          axisLine: {
            lineStyle: {
              color: '#aaa',
              type: 'dotted'
            }
          }
        },
        series: series
      });
    }
  }
});

/***/ }),

/***/ 88:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_resize__ = __webpack_require__(93);
//
//
//
//

/* global echarts */
// require('echarts/theme/macarons') // echarts theme


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_resize__["a" /* default */]],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    chartTitle: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    chartData: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },

  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initChart();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },

  methods: {
    initChart: function initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions(this.chartData);
    },
    setOptions: function setOptions(expectedData) {
      this.chart.setOption({
        title: {
          text: this.chartTitle,
          left: 'center',
          top: 0,
          textStyle: {
            color: '#61a0a8'
          }
        },
        tooltip: {
          trigger: 'item',
          formatter: '{b} : {c} ({d}%)'
        },
        color: ['#c23531', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
        series: [{
          type: 'pie',
          radius: [15, 75],
          label: {
            normal: {
              formatter: '{b} : {c}',
              position: 'inside'
            }
          },
          center: 'center',
          data: expectedData,
          animationEasing: 'cubicInOut',
          animationDuration: 2600
        }]
      });
    }
  }
});

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_resize__ = __webpack_require__(93);
//
//
//
//

/* global echarts, $config */


/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_resize__["a" /* default */]],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '600px'
    },
    chartData: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      chart: null
    };
  },

  watch: {
    chartData: {
      deep: true,
      handler: function handler(val) {
        this.setOptions(val);
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.$nextTick(function () {
      _this.initChart();
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },

  methods: {
    initChart: function initChart() {
      this.chart = echarts.init(this.$el, 'macarons');
      this.setOptions(this.chartData);
    },
    setOptions: function setOptions(expectedData) {
      var _this2 = this;

      this.chart.setOption({
        backgroundColor: 'transparent',
        title: {
          text: '',
          subtext: '',
          left: 'center',
          textStyle: {
            color: '#fff'
          }
        },
        tooltip: {
          trigger: 'item'
        },
        bmap: {
          center: $config.mapCenter,
          zoom: $config.zoomLevel,
          roam: true,
          mapStyle: {
            styleJson: [{
              'featureType': 'water',
              'elementType': 'all',
              'stylers': {
                'color': '#044161'
              }
            }, {
              'featureType': 'land',
              'elementType': 'all',
              'stylers': {
                'color': '#283443'
              }
            }, {
              'featureType': 'boundary',
              'elementType': 'geometry',
              'stylers': {
                'color': '#064f85'
              }
            }, {
              'featureType': 'railway',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'highway',
              'elementType': 'geometry',
              'stylers': {
                'color': '#004981'
              }
            }, {
              'featureType': 'highway',
              'elementType': 'geometry.fill',
              'stylers': {
                'color': '#005b96',
                'lightness': 1
              }
            }, {
              'featureType': 'highway',
              'elementType': 'labels',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'arterial',
              'elementType': 'geometry',
              'stylers': {
                'color': '#004981'
              }
            }, {
              'featureType': 'arterial',
              'elementType': 'geometry.fill',
              'stylers': {
                'color': '#00508b'
              }
            }, {
              'featureType': 'poi',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'green',
              'elementType': 'all',
              'stylers': {
                'color': '#056197',
                'visibility': 'off'
              }
            }, {
              'featureType': 'subway',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'manmade',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'local',
              'elementType': 'all',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'arterial',
              'elementType': 'labels',
              'stylers': {
                'visibility': 'off'
              }
            }, {
              'featureType': 'boundary',
              'elementType': 'geometry.fill',
              'stylers': {
                'color': '#029fd4'
              }
            }, {
              'featureType': 'building',
              'elementType': 'all',
              'stylers': {
                'color': '#1a5787'
              }
            }, {
              'featureType': 'label',
              'elementType': 'labels.text.fill',
              'stylers': {
                'color': '#009e96'
              }
            }, {
              'featureType': 'label',
              'elementType': 'labels.text.stroke',
              'stylers': {
                'color': '#283443'
              }
            }]
          }
        },
        series: [{
          name: '车位数',
          type: 'effectScatter',
          // type: 'scatter',
          coordinateSystem: 'bmap',
          data: expectedData,
          encode: {
            value: 2
          },
          showEffectOn: 'emphasis',
          rippleEffect: {
            brushType: 'stroke'
          },
          hoverAnimation: true,
          symbolSize: $config.symbolSize,
          tooltip: {
            formatter: function formatter(params) {
              // var res
              // res = '<div><span style="font-weight: bold;">大车位：</span>' + params.value[2] + '个</div>' +
              //   '<div><span style="font-weight: bold;">小车位：</span>' + params.value[3] + '个</div>'
              return '';
            }
          },
          label: {
            formatter: '{b}',
            position: 'right',
            fontSize: '18',
            fontWeight: 'bold',
            show: true
          },
          itemStyle: {
            color: '#ddb926',
            shadowBlur: 10,
            shadowColor: '#333'
          },
          emphasis: {
            label: {
              show: true
            }
          }
        }]
      });
      this.chart.on('finished', function () {
        var bdElements = document.getElementsByClassName(' anchorBL');
        if (bdElements && bdElements.length) {
          for (var i = 0; i < bdElements.length; i++) {
            bdElements[i].style.display = 'none';
          }
        }
      });
      this.chart.on('click', function (params) {
        _this2.$emit('parkChange', params.dataIndex, params.value[4]);
      });
    }
  }
});

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app',
  created: function created() {
    document.title = this.$utils.getSiteTitle();
  }
});

/***/ }),

/***/ 93:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_other__ = __webpack_require__(177);


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      $_sidebarElm: null,
      $_resizeHandler: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.$_resizeHandler = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__utils_other__["a" /* debounce */])(function () {
      if (_this.chart) {
        _this.chart.resize();
      }
    }, 100);
    this.$_initResizeEvent();
    this.$_initSidebarResizeEvent();
  },
  beforeDestroy: function beforeDestroy() {
    this.$_destroyResizeEvent();
    this.$_destroySidebarResizeEvent();
  },

  // to fixed bug when cached by keep-alive
  // https://github.com/PanJiaChen/vue-element-admin/issues/2116
  activated: function activated() {
    this.$_initResizeEvent();
    this.$_initSidebarResizeEvent();
  },
  deactivated: function deactivated() {
    this.$_destroyResizeEvent();
    this.$_destroySidebarResizeEvent();
  },

  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_initResizeEvent: function $_initResizeEvent() {
      window.addEventListener('resize', this.$_resizeHandler);
    },
    $_destroyResizeEvent: function $_destroyResizeEvent() {
      window.removeEventListener('resize', this.$_resizeHandler);
    },
    $_sidebarResizeHandler: function $_sidebarResizeHandler(e) {
      if (e.propertyName === 'width') {
        this.$_resizeHandler();
      }
    },
    $_initSidebarResizeEvent: function $_initSidebarResizeEvent() {
      this.$_sidebarElm = document.getElementsByClassName('sidebar-container')[0];
      this.$_sidebarElm && this.$_sidebarElm.addEventListener('transitionend', this.$_sidebarResizeHandler);
    },
    $_destroySidebarResizeEvent: function $_destroySidebarResizeEvent() {
      this.$_sidebarElm && this.$_sidebarElm.removeEventListener('transitionend', this.$_sidebarResizeHandler);
    }
  }
});

/***/ })

},[175]);


// WEBPACK FOOTER //
// static/js/index.a2885d9831f604302ba2.js